var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.c()},[_c('div',{class:_vm.c('item', {current: true})},[_vm._v("\n    "+_vm._s(_vm.currentStep)+"\n  ")]),_vm._v("\n  of\n  "),_c('div',{class:_vm.c('item')},[_vm._v("\n    "+_vm._s(_vm.totalStepsText)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }